import Translator from '@andreasremdt/simple-translator';
import bsJson from '../i18n/bs.json';
import enJson from '../i18n/en.json';

let language_set = '';
export function setLanguage(language){
    if (language_set === '') {
        window.translator = new Translator();
        window.translator.add('bs', bsJson);
        window.translator.add('en', enJson);
        window.translator.translatePageTo(language);
        language_set = language;
    }
}
export function getLanguage() {
    const newURL =
        window.location.protocol +
        "://" +
        window.location.host +
        "/" +
        window.location.pathname;
    const pathArray = window.location.pathname.split("/");
    let segment_1 = pathArray[1];

    if (segment_1 == '') {
        segment_1 = 'bs';
    }

    return segment_1;
}

window.language_json = [];
window.language_json['bs'] = require('../i18n/bs.json');
window.language_json['en'] = require('../i18n/en.json');
